import React, { Component } from 'react';

import { Dropzone } from 'components/ClubComponents';
import { Button } from 'components/cosmos';
import { translate } from 'components/translate';
import { isNil, isEmpty } from 'helpers/Array';
import { getFileLink } from 'modules/file/helpers';
import PropTypes from 'prop-types';

import { ENTITY_TYPE } from './constants';
import PersonaAvatar from './PersonaAvatar';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

import './AvatarDropzone.scss';

@translate()
@UploadConsumer(ENTITY_TYPE)
class AvatarDropzone extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    t: PropTypes.func,
    value: PropTypes.string,
    fileUpload: UploadProptypes.fileUpload
  };

  constructor(props) {
    super(props);

    this.state = {
      showActions: false,
      hasError: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { props, state } = this;

    const propsChanged = ['disabled', 'name', 'value'].some(
      (prop) => props[prop] !== nextProps[prop]
    );
    const stateChanged = ['showActions', 'hasError'].some(
      (prop) => state[prop] !== nextState[prop]
    );

    return propsChanged || stateChanged;
  }

  get id() {
    const { value } = this.props;

    return value;
  }

  get src() {
    if (isNil(this.id)) {
      return null;
    }

    return getFileLink(this.id);
  }

  get uploadActions() {
    const { fileUpload } = this.props;

    return fileUpload && fileUpload.actions;
  }

  handleClear = (event) => {
    // Avoid file input to be triggered
    event.stopPropagation();
    this.uploadActions && this.uploadActions.delete(this.id);
  };

  handleChange = ({ value: files }) => {
    if (isEmpty(files) || !this.uploadActions) {
      return;
    }

    this.setState(
      {
        showActions: false,
        hasError: false
      },
      () => {
        const [file] = files;

        this.uploadActions.delete(this.id);
        this.uploadActions.sendMultiples([file]);
      }
    );
  };

  handleLoad = () => {
    const src = this.src;

    !isNil(src) && this.setState({ showActions: true, hasError: false });
  };

  handleError = () => {
    this.setState({ showActions: false, hasError: true });
  };

  renderAvatar = ({ openFileDialog: pickFile }) => {
    const { disabled, t } = this.props;
    const { showActions, hasError } = this.state;

    const src = this.src;

    return (
      <>
        <PersonaAvatar
          disabled={disabled}
          src={src}
          size={152}
          onLoad={this.handleLoad}
          onError={this.handleError}
        />

        <div className="_d-flex _align-items-center _justify-content-center _mt-2">
          {(!src || showActions || hasError) && (
            <Button
              type="button"
              variation="secondary"
              size="sm"
              onClick={pickFile}
              className="_d-flex-grow"
            >
              {t('general.edit')}
            </Button>
          )}
          {src && showActions && (
            <Button
              type="button"
              variation="danger"
              size="sm"
              onClick={this.handleClear}
              className="_d-flex-grow _ml-2"
            >
              {t('general.exclude')}
            </Button>
          )}
        </div>
      </>
    );
  };

  render() {
    const { disabled } = this.props;

    return (
      <div className="ca-avatar-dropzone _d-block _p-0 _m-0">
        <Dropzone
          borderless
          accept="image/png, image/jpeg"
          className="_d-inline-block"
          disabled={disabled}
          name="personaAvatarDropzone"
          onChange={this.handleChange}
        >
          {this.renderAvatar}
        </Dropzone>
      </div>
    );
  }
}

AvatarDropzone.defaultProps = {
  value: null
};

export default AvatarDropzone;
